<template>
  <div>
    <div class="color-div"></div>
    <div class="card-div">
      <div class="card">
        <div class="card-text-div">
          <div>星巴克自助代点餐</div>
        </div>
      </div>
    </div>

    <div class="form-div">
      <div class="coupon-detail" v-if="ticketCode">
        <div class="coupom-left">
          <img src="../assets/xingbake_1.png" alt="" />
        </div>
        <div class="coupom-right">
          <div class="item-name">
            {{
              parseFloat(ticketObj.Price) == 38
                ? "中杯通兑券"
                : ticketObj.Price + "元在线点单代金券"
            }}
          </div>
          <div style="color: #414141">优惠券码：{{ ticketObj.ticketCode }}</div>
          <div style="color: #666">本券不找零不兑现，不可拆分使用</div>
          <div style="color: #999999">
            有效期至：{{ ticketObj.InvalidationDate }}
          </div>
        </div>
      </div>
      <div class="login-div">
        <van-field v-model="mobile" type="digit" placeholder="请输入手机号">
          <template #left-icon>
            <img class="login-icon" src="../assets/phone.png" />
          </template>
        </van-field>
      </div>

      <div class="verify-div">
        <PhoneVerify
          :verifyType="verifyType"
          :mobile="mobile"
          :verifyCount="verifyCount"
          @changeType="changeType"
          @back="aftVerify"
        ></PhoneVerify>
        <Notes :hasPhone="mobile != '' && mobile.length == 11"></Notes>
      </div>

      <div class="login-div" v-if="showCode">
        <van-row>
          <van-col span="14">
            <van-field v-model="code" type="digit" placeholder="请输入验证码">
              <template #left-icon>
                <img class="login-icon" src="../assets/code.png" />
              </template>
            </van-field>
          </van-col>
          <van-col span="10">
            <div class="code-btn">
              <van-button
                @click="getCode()"
                plain
                :disabled="codeMsg != '获取验证码' || this.mobile.length != 11"
                color="#2e6c43"
                type="primary"
                >{{ codeMsg }}</van-button
              >
            </div>
          </van-col>
        </van-row>
      </div>
    </div>

    <div class="login-btn">
      <van-button
        round
        color="#2e6c43"
        type="primary"
        :disabled="code.length != 6"
        @click="login()"
        >登陆</van-button
      >
    </div>
  </div>
</template>

<script>
import PhoneVerify from "../components/phoneVerify/PhoneVerify.vue";
import Notes from "../components/phoneVerify/Notes.vue";
import { smsSend, mobileLogin, getCouponInfo } from "@/request/api";
import { Field, Cell, Button, Col, Row, Notify } from "vant";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "login",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Notify.name]: Notify,
    [PhoneVerify.name]: PhoneVerify,
    [Notes.name]: Notes,
  },
  data() {
    return {
      verifyCount: 0,
      verifyType: 0,
      showCode: false,
      showVerify: false,
      shake: false,
      mobile: "",
      code: "",
      codeTime: 60,
      codeMsg: "获取验证码",
      codeTimer: "",
      ticketCode: null,
      map:null,
      ticketObj: {
        Price: 0,
      },
    };
  },
  created() {
    this.ticketCode = this.$getUrlParam("tc");

    if (this.ticketCode) {
      this.forTicketLinkData();
    }
    if (history && history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goback, false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.goback);
  },
  methods: {
    ...mapMutations(["sSetToken"]),
    onError(e){
      console.log(e,'error');
    },
    onComplete(e){
      console.log(e,'success');
    },
    //获取验证码
    getCode() {
      //发送短信
      if (this.mobile.length != 11) {
        Notify({ type: "danger", message: "手机号格式错误" });
      } else {
        //开启定时器
        this.codeMsg = this.codeTime + "秒后重试";
        this.codeTimer = setInterval(this.reduceTime, 1000);
        this.sendCode();
      }
    },
    forTicketLinkData() {
      getCouponInfo({
        ticketCode: this.ticketCode,
      }).then((res) => {
        // console.log(res);
        this.ticketObj = res;
        // Notify({ type: 'success', message: '验证码已发送' });
      });
    },
    changeType(type) {
      this.verifyType = type;
      if (type == 2) {
        this.showCode = true;
        if (this.codeMsg == "获取验证码") {
          this.getCode();
        }
      } else {
        this.showCode = false;
        this.code = "";
        this.verifyCount++;
      }
    },
    aftVerify() {
      this.doLogin();
      this.verifyCount = 0;
      this.verifyType = 0;
      this.showCode = false;
      this.code = "";
      this.showVerify = false;
    },
    //axios获取验证码
    sendCode() {
      smsSend({
        mobile: this.mobile,
      }).then((res) => {
        // console.log(res);
        Notify({ type: "success", message: "验证码已发送" });
      });
    },
    //axios登陆
    login() {
      if (!this.code || this.code.length != 6) {
        Notify({ type: "danger", message: "验证码格式错误" });
      } else {
        this.doLogin();
      }
    },
    doLogin() {
      let platformCode = this.$getUrlParam("id");
      //调用登入接口
      // 有个通用验证码
      mobileLogin({
        mobile: this.mobile,
        provider: 1, // 服务商写死
        code: this.code,
        platformCode: platformCode,
        ticketCode: this.ticketCode,
      }).then((res) => {
        //存放token
        this.sSetToken(res);
        // this.getPayWay(platformCode)
        //跳转到之前到页面
        if (this.ticketCode) {
          this.$router.push("coupon");
        } else {
          this.$router.push("home");
        }
      });
    },
    //定时器-验证码
    reduceTime() {
      this.codeTime--;
      if (this.codeTime == 0) {
        console.log("----------");
        clearInterval(this.codeTimer);
        this.codeTime = 60;
        this.codeMsg = "获取验证码";
      } else {
        this.codeMsg = this.codeTime + "秒后重试";
      }
    },
	goback() {
      history.go(-2);
    },
  },
};
</script>

<style scoped>
.color-div {
  position: fixed;
  width: 100%;
  height: 20px;
  top: 50px;
  left: 0px;
  z-index: 0;
  background: linear-gradient(#c7a978, #e3cba7);
}
.coupon-detail {
  width: 300px;
  height: 103px;
  background: url("../assets/pack.png") no-repeat;
  background-size: 300px 103px;
  margin: 0 auto;
  margin-bottom: 20px;
  display: flex;
  padding: 20px 30px;
  justify-content: space-between;
  align-items: center;
}
.coupom-left img {
  width: 67px;
  height: 67px;
}
.coupom-right {
  font-size: 10px;
}
.coupom-right .item-name {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
}
.card-div {
  z-index: 1;
  top: 0px;
  left: 0px;
  position: fixed;
  width: 100%;
  height: 170px;
  padding: 10px 10px;
}
.card {
  width: 100%;
  height: 100%;
  background-image: url(../assets/index_card_bg.jpg);
  background-size: 100% 100%;
}
.card-text-div {
  padding-left: 88px;
  padding-top: 37px;
  font-size: 15px;
  color: #c8a665;
  font-weight: 500;
}

.form-div {
  padding-top: 200px;
}

.login-div {
  padding: 10px 30px;
}

.login-div .van-cell {
  /* border-radius: 50px; */
  border-radius: 5px;
  border: solid 1px #b0b0b0;
  padding: 10px 15px 0px 15px;
}

.login-div /deep/ .van-field__control {
  padding-top: 10px;
  height: 30px;
  font-size: 16px;
}

.login-icon {
  width: 35px;
  height: 35px;
}

.code-btn {
  text-align: center;
}

.code-btn button {
  padding: 26px 15px;
  width: auto;
}

.login-btn {
  margin-top: 50px;
  padding: 0px 20px;
}

.login-btn > button {
  width: 100%;
  height: 55px;
}

.login-btn .van-button__content {
  font-size: 19px;
}

.verify-div {
  padding: 0 30px;
}
</style>
